import { render, staticRenderFns } from "./recordFriends.vue?vue&type=template&id=1830e2de&scoped=true&"
import script from "./recordFriends.vue?vue&type=script&lang=js&"
export * from "./recordFriends.vue?vue&type=script&lang=js&"
import style0 from "./recordFriends.vue?vue&type=style&index=0&id=1830e2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830e2de",
  null
  
)

export default component.exports